"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaTags = void 0;
const react_1 = __importDefault(require("react"));
const constants_1 = require("./constants");
const MetaTags = ({ locale, showDefaultDescription = true }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("meta", { name: "apple-mobile-web-app-title", content: "Eventbrite" }),
    react_1.default.createElement("meta", { name: "application-name", content: "Eventbrite" }),
    react_1.default.createElement("meta", { name: "msapplication-TileColor", content: constants_1.EB_DEFAULT_ORANGE_HEX }),
    react_1.default.createElement("meta", { name: "theme-color", content: constants_1.EB_DEFAULT_ORANGE_HEX }),
    react_1.default.createElement("meta", { name: "msapplication-TileImage", content: constants_1.MS_APP_TILE_IMG_PATH }),
    react_1.default.createElement("meta", { name: "y_key", content: constants_1.YAHOO_KEY }),
    react_1.default.createElement("meta", { name: "msvalidate.01", content: constants_1.BING_WEBMASTER_VERIFICATION }),
    react_1.default.createElement("meta", { property: "fb:app_id", content: constants_1.FB_APP_ID }),
    showDefaultDescription && (react_1.default.createElement("meta", { name: "description", content: "Eventbrite - Discover the Best Local Events & Things to Do" })),
    react_1.default.createElement("meta", { charSet: "utf-8" }),
    react_1.default.createElement("meta", { httpEquiv: "X-UA-Compatible", content: "IE=edge,chrome=1" }),
    locale && react_1.default.createElement("meta", { httpEquiv: "Content-Language", content: locale.slice(0, 2) })));
exports.MetaTags = MetaTags;
//# sourceMappingURL=MetaTags.js.map